import overViewActive from "../assets/svgIcons/overviewActive.svg";
import OverViewIcon from "../Icons/OverIcon";


export const navigation: any = [
  {
    name: "Dashboard",
    href: "/",
    icon: "",
    children: [
      {
        name: "Overview",
        href: "/",
        icon: OverViewIcon,
        activeIcon: overViewActive,
      },
      
    ],
  },
  {
    name: "Operations",
    href: "/",
    icon: "",
    children: [
      {
        name: "Consignment",
        href: "/order?limit=10&page=0",
        icon: OverViewIcon,
        activeIcon: OverViewIcon,
        children: [],
      },
      {
        name: "Ticket",
        href: "/ticket?limit=10&page=0",
        icon: OverViewIcon,
        activeIcon: OverViewIcon,
        children: [],
      },
    ],
  },
  {
    name: "Administration",
    href: "/",
    icon: "",
    children: [
      {
        name: "Branch",
        href: "/branch?limit=10&page=0",
        icon: OverViewIcon,
        activeIcon: OverViewIcon,
      },
      {
        name: "Delivery Charge",
        href: "/delivery-charge?limit=10&page=0",
        icon: OverViewIcon,
        activeIcon: OverViewIcon,
      },
      {
        name: "API Integration",
        href: "/api-integration",
        icon: OverViewIcon,
        activeIcon: OverViewIcon,
      },
    ],
  },
  {
    name: "Finance",
    href: "/",
    icon: "",
    children: [
      {
        name: "Invoice",
        href: "/invoice?limit=10&page=0",
        icon: OverViewIcon,
        activeIcon: OverViewIcon,
      },
    ],
  },
];
